<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  [ngClass]="class"
  [ngSwitch]="name"
>
  <!-- Trophy -->
  <ng-container *ngSwitchCase="'trophy'">
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </ng-container>

  <!-- Edit / Pencil -->
  <ng-container *ngSwitchCase="'edit'">
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </ng-container>

  <!-- Users -->
  <ng-container *ngSwitchCase="'users'">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </ng-container>

  <!-- Shield -->
  <ng-container *ngSwitchCase="'shield'">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </ng-container>

  <!-- Coins -->
  <ng-container *ngSwitchCase="'coins'">
    <circle cx="8" cy="8" r="6" />
    <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
    <path d="M7 6h1v4" />
    <path d="m16.71 13.88.7.71-2.82 2.82" />
  </ng-container>

  <!-- TrendingUp -->
  <ng-container *ngSwitchCase="'trending-up'">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
    <polyline points="16 7 22 7 22 13" />
  </ng-container>

  <!-- DollarSign -->
  <ng-container *ngSwitchCase="'dollar-sign'">
    <line x1="12" x2="12" y1="2" y2="22" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </ng-container>

  <!-- Calendar -->
  <ng-container *ngSwitchCase="'calendar'">
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
  </ng-container>

  <!-- Building2 -->
  <ng-container *ngSwitchCase="'building'">
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" />
    <path d="M10 10h4" />
    <path d="M10 14h4" />
    <path d="M10 18h4" />
  </ng-container>

  <!-- Play -->
  <ng-container *ngSwitchCase="'play'">
    <polygon points="6 3 20 12 6 21 6 3" />
  </ng-container>

  <!-- ArrowRight -->
  <ng-container *ngSwitchCase="'arrow-right'">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </ng-container>

  <!-- ArrowUpRight -->
  <ng-container *ngSwitchCase="'arrow-up-right'">
    <path d="M7 17 17 7" />
    <path d="M7 7h10v10" />
  </ng-container>

  <!-- Check -->
  <ng-container *ngSwitchCase="'check'">
    <polyline points="20 6 9 17 4 12" />
  </ng-container>

  <!-- CheckCircle2 -->
  <ng-container *ngSwitchCase="'check-circle'">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <path d="m9 11 3 3L22 4" />
  </ng-container>

  <!-- Info -->
  <ng-container *ngSwitchCase="'info'">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </ng-container>

  <!-- AlertCircle -->
  <ng-container *ngSwitchCase="'alert-circle'">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </ng-container>

  <!-- Bell -->
  <ng-container *ngSwitchCase="'bell'">
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </ng-container>

  <!-- BellOff -->
  <ng-container *ngSwitchCase="'bell-off'">
    <path d="M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5" />
    <path d="M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    <line x1="2" x2="22" y1="2" y2="22" />
  </ng-container>

  <!-- Clock -->
  <ng-container *ngSwitchCase="'clock'">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </ng-container>

  <!-- ArrowDownUp -->
  <ng-container *ngSwitchCase="'arrow-down-up'">
    <path d="m3 16 4 4 4-4" />
    <path d="M7 20V4" />
    <path d="m21 8-4-4-4 4" />
    <path d="M17 4v16" />
  </ng-container>

  <!-- ArrowLeftRight -->
  <ng-container *ngSwitchCase="'arrow-left-right'">
    <path d="M8 3 4 7l4 4" />
    <path d="M4 7h16" />
    <path d="m16 21 4-4-4-4" />
    <path d="M20 17H4" />
  </ng-container>

  <!-- Layers -->
  <ng-container *ngSwitchCase="'layers'">
    <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
    <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" />
    <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" />
  </ng-container>

  <!-- ChevronDown -->
  <ng-container *ngSwitchCase="'chevron-down'">
    <path d="m6 9 6 6 6-6" />
  </ng-container>

  <!-- ChevronRight -->
  <ng-container *ngSwitchCase="'chevron-right'">
    <path d="m9 18 6-6-6-6" />
  </ng-container>

  <!-- ChevronLeft -->
  <ng-container *ngSwitchCase="'chevron-left'">
    <path d="m15 18-6-6 6-6" />
  </ng-container>

  <!-- Trash -->
  <ng-container *ngSwitchCase="'trash'">
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </ng-container>

  <!-- X -->
  <ng-container *ngSwitchCase="'x'">
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </ng-container>

  <!-- Search -->
  <ng-container *ngSwitchCase="'search'">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </ng-container>

  <!-- Filter -->
  <ng-container *ngSwitchCase="'filter'">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </ng-container>

  <!-- Sparkles -->
  <ng-container *ngSwitchCase="'sparkles'">
    <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z" />
  </ng-container>

  <!-- Plus -->
  <ng-container *ngSwitchCase="'plus'">
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </ng-container>

  <!-- Award -->
  <ng-container *ngSwitchCase="'award'">
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
  </ng-container>

  <!-- Activity -->
  <ng-container *ngSwitchCase="'activity'">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </ng-container>

  <!-- Flame -->
  <ng-container *ngSwitchCase="'flame'">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </ng-container>

  <!-- Zap -->
  <ng-container *ngSwitchCase="'zap'">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </ng-container>

  <!-- BarChart -->
  <ng-container *ngSwitchCase="'bar-chart'">
    <line x1="18" x2="18" y1="20" y2="10" />
    <line x1="12" x2="12" y1="20" y2="4" />
    <line x1="6" x2="6" y1="20" y2="14" />
  </ng-container>

  <!-- Settings -->
  <ng-container *ngSwitchCase="'settings'">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </ng-container>

  <!-- LogOut -->
  <ng-container *ngSwitchCase="'log-out'">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" x2="9" y1="12" y2="12" />
  </ng-container>

  <!-- RotateCcw -->
  <ng-container *ngSwitchCase="'rotate-ccw'">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
  </ng-container>

  <!-- Globe -->
  <ng-container *ngSwitchCase="'globe'">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" x2="22" y1="12" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </ng-container>

  <!-- Lock -->
  <ng-container *ngSwitchCase="'lock'">
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </ng-container>

  <!-- User -->
  <ng-container *ngSwitchCase="'user'">
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </ng-container>

  <!-- UserPlus -->
  <ng-container *ngSwitchCase="'user-plus'">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="19" x2="19" y1="8" y2="14" />
    <line x1="22" x2="16" y1="11" y2="11" />
  </ng-container>

  <!-- Star -->
  <ng-container *ngSwitchCase="'star'">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </ng-container>

  <!-- Star Half -->
  <ng-container *ngSwitchCase="'star-half'">
    <path d="M12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2v15.77z" fill="currentColor" />
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="none" stroke="currentColor" />
  </ng-container>

  <!-- Bookmark -->
  <ng-container *ngSwitchCase="'bookmark'">
    <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
  </ng-container>

  <!-- FileText -->
  <ng-container *ngSwitchCase="'file-text'">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" x2="8" y1="13" y2="13" />
    <line x1="16" x2="8" y1="17" y2="17" />
    <line x1="10" x2="8" y1="9" y2="9" />
  </ng-container>

  <!-- Eye -->
  <ng-container *ngSwitchCase="'eye'">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </ng-container>

  <!-- Store -->
  <ng-container *ngSwitchCase="'store'">
    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
    <path d="M2 7h20" />
    <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7" />
  </ng-container>

  <!-- Terminal -->
  <ng-container *ngSwitchCase="'terminal'">
    <polyline points="4 17 10 11 4 5" />
    <line x1="12" x2="20" y1="19" y2="19" />
  </ng-container>

  <!-- RefreshCw -->
  <ng-container *ngSwitchCase="'refresh-cw'">
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
    <path d="M16 21h5v-5" />
  </ng-container>

  <!-- Sun -->
  <ng-container *ngSwitchCase="'sun'">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </ng-container>

  <!-- Moon -->
  <ng-container *ngSwitchCase="'moon'">
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
  </ng-container>

  <!-- Newspaper -->
  <ng-container *ngSwitchCase="'newspaper'">
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
    <path d="M18 14h-8" />
    <path d="M15 18h-5" />
    <path d="M10 6h8v4h-8V6Z" />
  </ng-container>

  <!-- TV (Billboard) -->
  <ng-container *ngSwitchCase="'tv'">
    <rect width="20" height="15" x="2" y="7" rx="2" />
    <polyline points="17 2 12 7 7 2" />
  </ng-container>

  <!-- Briefcase -->
  <ng-container *ngSwitchCase="'briefcase'">
    <rect width="20" height="14" x="2" y="7" rx="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </ng-container>

  <!-- Badge Dollar Sign -->
  <ng-container *ngSwitchCase="'badge-dollar-sign'">
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
    <path d="M12 18V6" />
  </ng-container>

  <!-- Football shirt -->
  <ng-container *ngSwitchCase="'shirt'">
    <path d="M8 3 3 5 1 10l4 2 1-3v12h12V9l1 3 4-2-2-5-5-2" />
    <path d="M8 3a4 4 0 0 0 8 0" />
  </ng-container>

  <!-- Default circle if unknown -->
  <ng-container *ngSwitchDefault>
    <circle cx="12" cy="12" r="10" />
  </ng-container>
</svg>
